import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { FlexLayoutModule } from '@ngbracket/ngx-layout';
import { ClaimOverlayComponent } from './claim-overlay.component';
import { MatDialogModule } from '@angular/material/dialog';
import { CloseButtonModule } from '../../close-button/close-button.module';
import { MatIconModule } from '@angular/material/icon';
import { DlsDialogModule } from '@zelis/dls/dialog';
import { MatTooltipModule } from '@angular/material/tooltip';
import { SharedPipesModule } from '@zelis/shared/pipes';
import { DlsLozengeModule } from '@zelis/dls/lozenge';

@NgModule({
  imports: [
    CommonModule,
    TranslateModule,
    CloseButtonModule,
    MatIconModule,
    DlsDialogModule,
    MatTooltipModule,
    SharedPipesModule,
    DlsLozengeModule,
  ],
  declarations: [ClaimOverlayComponent],
  exports: [ClaimOverlayComponent],
})
export class ClaimOverlayModule {}
